import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["section"];

  show({ target: { value } }) {
    this.sectionTargets.forEach((section) => {
      section.hidden = section.dataset.resolutionMethodName !== value;
    });
  }
}
